<template>
  <div>
    <div class="loading-spinner-outer" v-if="loading">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
      </div>
    </div>
    <div style="background: transparent; position: absolute; top:0; left: 0; right: 0; bottom: 0;"
         @click="filter_dropdown_open = false" v-if="filter_dropdown_open"></div>
    <div class="page-title pt-0">
        <div class="flex-2xs ml-3 mr-3 mr-0-2xs ml-0-2xs">
          <div class="pl-2-2xs mb-1 mb-0-2xs" @click.stop>
            <div class="multi-select-input" @click.stop="filter_dropdown_open = !filter_dropdown_open"
                 style="min-width:250px;">
              <div class="multi-select-input-placeholder">
                Filter ...
                <div class="dropdown-icon">
                  <i class="fal fa-chevron-down"></i>
                </div>
              </div>
              <div class="multi-select-input-inner" v-show="filter_dropdown_open">
                <div class="multi-select-input-group">
                  <h1 class="input-group-title">Date</h1>
                  <div class="checkboxes">
                    <div class="" @click.stop>
                      <div class="input-group">
                        <div class="input-group-addon" style="width: 60px;">From:</div>
                        <datepicker input-class="form-control" v-model="date_filter_start"></datepicker>
                      </div>
                      <div class="input-group mt-1">
                        <div class="input-group-addon" style="width: 60px;">To:</div>
                        <datepicker input-class="form-control" v-model="date_filter_end"></datepicker>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="multi-select-input-group mt-3">
                  <h1 class="input-group-title">Log Type</h1>
                  <div class="checkboxes">
                    <div class="checkbox level-1">
                      <label>
                        <input type="checkbox" name="selected_log_types" value="Download" v-model="selected_log_types">
                        <span class="checkbox-label">Download</span>
                      </label>
                    </div>
                    <div class="checkbox level-1">
                      <label>
                        <input type="checkbox" name="selected_log_types" value="View" v-model="selected_log_types">
                        <span class="checkbox-label">View</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="multi-select-input-group mt-3">
                  <h1 class="input-group-title">Download Types</h1>
                  <div class="checkboxes">
                    <div class="checkbox level-1" v-for="type in all_content_upload_types">
                      <label>
                        <input type="checkbox" name="selected_type_ids" :value="type.id" v-model="selected_type_ids">
                        <span class="checkbox-label">{{ type.name }}</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="multi-select-input-group mt-3">
                  <h1 class="input-group-title">Tags</h1>
                  <div class="checkboxes">
                    <div class="checkbox level-1" v-for="tag in all_content_upload_tags">
                      <label>
                        <input type="checkbox" name="selected_tags" :value="tag.id" v-model="selected_tags">
                        <span class="checkbox-label">{{ tag.name }}</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="multi-select-input-group mt-3">
                  <h1 class="input-group-title">User Types</h1>
                  <div class="checkboxes">
                    <div class="checkbox level-1" v-for="user_type in all_user_types">
                      <label>
                        <input type="checkbox" name="selected_user_types" :value="user_type.id" v-model="selected_user_types">
                        <span class="checkbox-label">{{ user_type.label }}</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="multi-select-input-group mt-3">
                  <h1 class="input-group-title">Company Types</h1>
                  <div class="checkboxes">
                    <div class="checkbox level-1" v-for="company_type in all_company_types">
                      <label>
                        <input type="checkbox" name="selected_company_types" :value="company_type.id" v-model="selected_company_types">
                        <span class="checkbox-label">{{ company_type.label }}</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="multi-select-input-group mt-3">
                  <h1 class="input-group-title">System Types</h1>
                  <div class="checkboxes">
                    <div class="checkbox level-1" v-for="system_type in all_epwin_system_types">
                      <label>
                        <input type="checkbox" name="selected_system_types" :value="system_type.id" v-model="selected_system_types">
                        <span class="checkbox-label">{{ system_type.label }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="pl-2-2xs">
            <input type="text" v-model="search_query" class="form-control" placeholder="Search Document Name..."
                   style="width: 200px;">
          </div>
          <div class="pl-2-2xs">
            <input type="text" v-model="user_search_query" class="form-control" placeholder="Search User..."
                   style="width: 200px;">
          </div>
          <div class="pl-2-2xs">
            <a class="btn-primary" @click.prevent="exportDownloadLogs">
              Export
            </a>
          </div>
        </div>
    </div>
    <div class="box">
      <div class="box-content">
        <div>
          <table class="table _content-upload-logs">
            <tbody>
            <template v-for="log in logs">
              <tr class="log-info">
                <td>
                    <div class="flex-2xs">
                        <strong>Date:</strong> {{ log.formatted_created_at }}
                    </div>
                </td>
                <td colspan="3">
                    <div class="flex-2xs">
                        <strong>User:</strong>
                      {{ log.user.company.name }} ({{ log.user.company.company_type.label }}) - {{ log.user.name }}
                    </div>
                </td>
              </tr>
              <tr class="download-info">
                <td colspan="4">
                  <table>
                    <tr>
                      <td class="image">
                        <img
                            :src="`${$aws_bucket_url}${log.content_upload.thumbnail_url}`"
                            @error="imageFallbackIcon">
                      </td>
                      <td class="info">
                        <div class="flex-2xs">
                          <label>Name:</label> {{ log.content_upload.name }}
                        </div>
                        <div class="flex-2xs">
                          <label>Type:</label> {{ log.content_upload.content_upload_type.name }}
                        </div>
                        <div class="flex-2xs">
                          <label>Systems:</label> <span
                            v-for="(system_type, index) in log.content_upload.epwin_system_types"><template
                            v-if="index > 0">, </template>{{ system_type.label }} </span>
                        </div>
                        <div class="flex-2xs">
                          <label>Tags:</label> <span v-for="(tag, index) in log.content_upload.tags"> <template
                            v-if="index > 0">, </template> {{ tag.name }} </span>
                        </div>
                        <div class="flex-2xs">
                          <label>Type:</label> {{ log.log_type }}
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <template v-if="!loading && total_count > 0">
          <div class="pagination-bar wrapper mb-3 mt-3">
            <div class="row">
              <div class="col">
                <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                    class="fa fa-caret-left"></i></a>
                <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                   class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
              </div>
              <div class="col align-right">
                <div class="mt-1 mb-1">
                  {{ total_count }} results found
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="!loading && total_count === 0">
          <strong class="block mt-3 p-3">
            No Results Found
          </strong>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  props: [
      'logged_in_user',
      'all_content_upload_types',
      'all_company_types',
      'all_content_upload_tags',
      'all_epwin_system_types',
      'all_user_types',
  ],
  components: {
    'datepicker': Datepicker,
  },
  data() {
    return {
      search_query: '',
      selected_tags: [],
      selected_type_ids: [],
      selected_log_types: [],
      logs: [],
      loading: true,
      filter_dropdown_open: false,
      current_page: 1,
      total_count: 0,
      total_pages: 0,
      limit: 20,
      selected_company_types: [],
      selected_system_types: [],
      date_filter_start: null,
      date_filter_end: new Date(),
      user_search_query: '',
      selected_user_types: [],
    };
  },
  async mounted() {
    let starting_date = new Date();
    starting_date.setMonth(starting_date.getMonth() - 1);
    this.date_filter_start = starting_date;

    if (window.location.hash) {
      this.current_page = window.location.hash.substring(1);
    }

    await this.loadLogs();
  },
  methods: {
    loadLogs: _.debounce(function () {
      this.loading = true;
      axios.post('/downloads/getLogs', {
        selected_tags: this.selected_tags,
        selected_type_ids: this.selected_type_ids,
        selected_system_types: this.selected_system_types,
        selected_log_types: this.selected_log_types,
        selected_company_types: this.selected_company_types,
        search_query: this.search_query,
        user_search_query: this.user_search_query,
        page_number: this.current_page,
        limit: this.limit,
        date_filter_start: this.date_filter_start,
        date_filter_end: this.date_filter_end,
        selected_user_types: this.selected_user_types,
      }).then((response) => {
        this.logs = response.data.data;
        this.total_count = response.data.total;
        this.total_pages = response.data.last_page;
        this.loading = false;
      });
    }, 250),
    setPageHash() {
      window.location = `#${this.current_page}`;
    },
    isTagSelected(tag) {
      return this.selected_tags.filter(selected_tag => selected_tag === tag.id).length > 0;
    },
    prevPage() {
      this.current_page = this.current_page - 1;
      this.setPageHash();
      this.loadLogs();
    },
    nextPage() {
      this.current_page = this.current_page + 1;
      this.setPageHash();
      this.loadLogs();
    },
    imageFallbackIcon(event) {
      event.target.src = '/images/content-uploads-thumbnail-fallback-icon.png';
    },
    exportDownloadLogs() {
      this.loading = true;
      axios({
        url: '/downloads/exportDownloadLogs',
        method: 'POST',
        responseType: 'blob',
        data: {
          selected_tags: this.selected_tags,
          selected_type_ids: this.selected_type_ids,
          selected_system_types: this.selected_system_types,
          selected_log_types: this.selected_log_types,
          selected_company_types: this.selected_company_types,
          search_query: this.search_query,
          user_search_query: this.user_search_query,
          page_number: this.current_page,
          limit: this.limit,
          date_filter_start: this.date_filter_start,
          date_filter_end: this.date_filter_end,
          selected_user_types: this.selected_user_types,
        },
      }).then((response) => {
        this.loading = false;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'download_logs_export.xlsx'); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
  },
  watch: {
    search_query() {
      this.current_page = 1;
      this.loadLogs();
    },
    user_search_query() {
      this.current_page = 1;
      this.loadLogs();
    },
    selected_tags() {
      this.current_page = 1;
      this.loadLogs();
    },
    selected_type_ids() {
      this.current_page = 1;
      this.loadLogs();
    },
    selected_system_types() {
      this.current_page = 1;
      this.loadLogs();
    },
    selected_log_types() {
      this.current_page = 1;
      this.loadLogs();
    },
    selected_company_types() {
      this.current_page = 1;
      this.loadLogs();
    },
    date_filter_start() {
      this.current_page = 1;
      this.loadLogs();
    },
    date_filter_end() {
      this.current_page = 1;
      this.loadLogs();
    },
    selected_user_types() {
      this.current_page = 1;
      this.loadLogs();
    },
  },
};
</script>
